import React from "react";
import { Helmet } from "react-helmet";
import { headConstants } from "@utils/constants";
import { IndexableHead } from "./Indexable";
import i18n from "src/locales";

const LOCALE_PATTERN =
  /\/((?<locale>en|en-GB|en-AU|en-NZ|en-IE|es|es-ES|de|de-DE|ja|ja-JP|jp)\/)?/;
const HEALTH_WEIGHT = new RegExp(
  `^${LOCALE_PATTERN.source}programs/health-weight/`
);
const LOCALE_PATTERN_ESDEJA = /\/((?<locale>es|de|de-DE|es-ES|ja|ja-JP|jp)\/)?/;
const CANONICALIZE_TO_DIRECT_WHITELIST = [
  HEALTH_WEIGHT,
  new RegExp(`^${LOCALE_PATTERN_ESDEJA.source}healthy-weight-program`),
];
const DIRECT_HOME_PAGE_PATTERN = new RegExp(`^${LOCALE_PATTERN.source}$`);
const JP_LOCALE_PATTERN = /\/jp/; // NOTE(norbert): negative lookbehind does not work in safary in order to matche 'jp' but not 'ja-jp'. So we match /jp and replace it with /ja

const getCanonicalPathname = (pathname: string) => {
  const shouldCanonicalizeToDirect = CANONICALIZE_TO_DIRECT_WHITELIST.some(
    (pattern) => pattern.test(pathname)
  );
  if (shouldCanonicalizeToDirect) {
    // get the proper localized direct page.
    const matches = LOCALE_PATTERN.exec(pathname);
    return matches ? matches[0] : "/";
  }
  return pathname;
};

export const LandingHead = () => {
  const { pathname } = window.location;
  let canonicalPathname = getCanonicalPathname(pathname);
  // noom.com/ should have noom.com as canonical.
  canonicalPathname = canonicalPathname === "/" ? "" : canonicalPathname;
  const canonicalHref =
    window.location.origin +
    canonicalPathname.replace(JP_LOCALE_PATTERN, "/ja");

  return (
    <>
      <Helmet>
        <link href={canonicalHref} rel="canonical" />
        {DIRECT_HOME_PAGE_PATTERN.test(pathname) &&
          headConstants.homepageHrefLangMappings.map(({ href, hreflang }) => (
            <link
              href={href}
              rel="alternate"
              hrefLang={hreflang}
              key={hreflang}
            />
          ))}
      </Helmet>
      <IndexableHead />
    </>
  );
};

export const AWSemHead = () => (
  <>
    <Helmet>
      <meta name="keywords" content={i18n.t("meta:keywords")} />
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
  </>
);
